import gql from "graphql-tag";

export const CREATE_FOLDER = gql`
  mutation createFolder($data: FolderData) {
    createFolder(data: $data) {
      data {
        folderNum
      }
    }
  }
`;
export const UPDATE_FOLDER = gql`
  mutation updateFolder($where: FolderWhereInput, $data: UpdateFolderData) {
    updateFolder(where: $where, data: $data) {
      data
    }
  }
`;
